import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ConfirmationDialogComponent } from '../../components/confirmation-dialog/confirmation-dialog.component';
import { InlineSvgComponent } from '../../components/inline-svg/inline-svg.component';
import { ShareModalComponent } from '../../components/share-modal/share-modal.component';
import { UserLogoComponent } from '../../components/user-logo/user-logo.component';
import { Project } from '../../models/project.module';
import { User } from '../../models/user.model';
import { ProjectService } from '../../services/project.service';
import { ToastNotificationService } from '../../services/toast-notification.service';
import { NewProjectService } from '../../services/newProject.service';

@Component({
  selector: 'frmg-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss'],
  imports: [InlineSvgComponent, MatButton, UserLogoComponent, RouterOutlet]
})
export class ProjectsComponent implements OnInit {
  public id: string;
  public currentUser: User;
  public project: Project;

  constructor(
    private router: Router,
    private projectService: ProjectService,
    private newProjectService: NewProjectService,
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private toastNotificationService: ToastNotificationService
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('user')) as User;
  }

  ngOnInit(): void {
    const url = this.router.url;
    this.id = url.match(/\/details\/([^/?#]+)/)?.[1];
    this.updateProject();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.id = event.url.match(/\/details\/([^/?#]+)/)?.[1];
        if (this.id) this.updateProject();
      }
    });
  }

  public updateProject() {
    if (this.id)
      this.newProjectService
        .getProjectManagementById(this.id)
        .subscribe((project) => {
          // @ts-ignore
          this.project = project;
          // @ts-ignore
          this.project.shared_with = [this.project.user];
          this.cd.detectChanges();
        });
  }

  public openOnMap() {
    this.router.navigate([`/risk-map/${this.project.path}`]);
  }

  public shareProject() {
    this.dialog
      .open(ShareModalComponent<Project>, {
        data: {
          entity: this.project
        }
      })
      .afterClosed()
      .subscribe(() => {
        this.updateProject();
      });
  }

  public deleteProject() {
    this.dialog
      .open<ConfirmationDialogComponent>(ConfirmationDialogComponent, {
        width: '640px',
        data: {
          header: 'Are you sure you want to delete this project?',
          body: 'Permanently deleting this project will remove it for you and all users with access. All related data — uploads, downloads, and reports — will be permanently deleted and cannot be restored.',
          confirmText: 'Delete'
        }
      })
      .afterClosed()
      .subscribe((del) => {
        if (del)
          this.projectService.deleteProject(this.id).subscribe(() => {
            this.toastNotificationService.showNotification({
              type: 'success',
              message: 'Project deleted Successfully'
            });
            this.goToList();
            this.project = null;
            this.id = null;
          });
      });
  }

  public archiveProject() {
    event.stopPropagation();
    this.dialog
      .open<ConfirmationDialogComponent>(ConfirmationDialogComponent, {
        width: '640px',
        data: {
          header: `Are you sure you want to ${
            !this.project.is_archived ? 'archive' : 'unarchive'
          } this project?`,
          body: !this.project.is_archived
            ? 'Archived projects can be restored anytime.'
            : 'Unarchived projects are saved in "My Projects".',
          confirmText: !this.project.is_archived ? 'Archive' : 'Unarchive'
        }
      })
      .afterClosed()
      .subscribe((del) => {
        if (del) {
          this.projectService.archiveProject(this.project).subscribe(() => {
            this.toastNotificationService.showNotification({
              type: 'success',
              message: `Project was ${
                !this.project.is_archived ? 'archived' : 'unarchived'
              } successfully`
            });

            this.updateProject();
          });
        }
      });
  }

  public goToList() {
    this.router.navigate(['/projects']);
  }

  public moreUsers(): User {
    // @ts-ignore
    if (this.project.shared_with.length == 3) {
      // @ts-ignore
      return this.project.shared_with[2];
    } else {
      return {
        id: '0',
        teams: [],
        // @ts-ignore
        email: `+${this.project.shared_with.length - 2}`
      };
    }
  }
}
